var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77777 10.4603L6.26596 10.9721L6.82969 11.5359L7.3365 10.9205L6.77777 10.4603ZM4.15485 8.86103L6.26596 10.9721L7.28958 9.94852L5.17847 7.83741L4.15485 8.86103ZM7.3365 10.9205L11.5587 5.79347L10.4413 4.87321L6.21904 10.0002L7.3365 10.9205Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "rgba(173, 44, 211)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77777 10.4603L6.26596 10.9721L6.82969 11.5359L7.3365 10.9205L6.77777 10.4603ZM4.15485 8.86103L6.26596 10.9721L7.28958 9.94852L5.17847 7.83741L4.15485 8.86103ZM7.3365 10.9205L11.5587 5.79347L10.4413 4.87321L6.21904 10.0002L7.3365 10.9205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.abe1e684a4f950543ef9e7941cbe486b.svg";
export { ForwardRef as ReactComponent };